import { createFileRoute } from '@tanstack/react-router';
import { DocumentsPage } from '@/features/documents/documents-page';

export const Route = createFileRoute('/_app/documents')({
  // ?f=<klasör id | none> — the divider the rail has open survives a refresh, and
  // browser back returns to the folder the user came from (W-31 §4)
  validateSearch: (s: Record<string, unknown>): { f?: string } => ({ f: typeof s.f === 'string' && s.f ? s.f : undefined }),
  component: function Documents() {
    const { f } = Route.useSearch();
    return <DocumentsPage folderId={f} />;
  },
});
